import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class GroupOrderComponent extends Component {
  static readonly TYPE_ID: string = '4ab97b7a823747b88567b44c1c4740c7';

  constructor(
    public readonly serviceId: string,
    public readonly groupSize: number,
    public readonly reservationId: string | null = null,
    public readonly groupId: string | null = null,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return GroupOrderComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): GroupOrderComponent {
    return new GroupOrderComponent(
        MapUtils.get<string>(map, 'serviceId'),
        MapUtils.get<number>(map, 'groupSize'),
        MapUtils.getOrNull<string>(map, 'reservationId'),
        MapUtils.getOrNull<string>(map, 'groupId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'serviceId': this.serviceId,
      'groupSize': this.groupSize,
      'reservationId': this.reservationId,
      'groupId': this.groupId,
    };
  }

  clone(): this {
    return new GroupOrderComponent(
        this.serviceId,
        this.groupSize,
        this.reservationId,
        this.groupId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.serviceId === this.serviceId &&
        other.groupSize === this.groupSize &&
        other.reservationId === this.reservationId &&
        other.groupId === this.groupId;
  }
}

export class GroupOrderComponentBuilder extends DataModelBuilder<GroupOrderComponent> {
  build(context: SerializationContext, map: SerializedData): GroupOrderComponent {
    return GroupOrderComponent.fromMap(context, map);
  }
}
